export default class MaterialGroups {
  static footRestMaterials(configMap, props) {
    return [
      {
        targets: configMap["FOOTREST"]["_footrest_color"].targets,
        material: props.config["FOOTREST"]["_footrest_color"],
      },
      {
        targets: configMap["FOOTREST"]["_footrest_carbon"].targets,
        material: props.config["FOOTREST"]["_footrest_carbon"],
      },
    ];
  }

  static wheelLocksMaterials(configMap, props) {
    return [
      {
        targets: configMap["WHEEL_LOCKS"]["_wheel_locks_color"].targets,
        material: props.config["WHEEL_LOCKS"]["_wheel_locks_color"],
      },
      {
        targets: configMap["WHEEL_LOCKS"]["_handled_color"].targets,
        material: props.config["WHEEL_LOCKS"]["_handled_color"],
      },
    ];
  }

  static addOnMaterials(configMap, props) {
    return [
      {
        targets: configMap["ADDONS"]["_addons_metal_color"].targets,
        material: props.config["ADDONS"]["_addons_metal_color"],
      },
      {
        targets: configMap["ADDONS"]["_addons_rubber_color"].targets,
        material: props.config["ADDONS"]["_addons_rubber_color"],
      },
      {
        targets: configMap["ADDONS"]["_addons_chrome_color"].targets,
        material: props.config["ADDONS"]["_addons_chrome_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_metal_black_color"].targets,
        material: props.config["ADDONS"]["_f55_metal_black_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_metal_silver_color"].targets,
        material: props.config["ADDONS"]["_f55_metal_silver_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_rubber_color"].targets,
        material: props.config["ADDONS"]["_f55_rubber_color"],
      },
      {
        targets: configMap["ADDONS"]["f55_color"].targets,
        material: props.config["ADDONS"]["f55_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_glass_color"].targets,
        material: props.config["ADDONS"]["_f55_glass_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_tyre8_color"].targets,
        material: props.config["ADDONS"]["_f55_tyre8_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_tyre14_color"].targets,
        material: props.config["ADDONS"]["_f55_tyre14_color"],
      },
      {
        targets: configMap["ADDONS"]["_f55_handgrip"].targets,
        material: props.config["ADDONS"]["_f55_handgrip"],
      },
      {
        targets: configMap["ADDONS"]["_f55_cruisecontrolbutton"].targets,
        material: props.config["ADDONS"]["_f55_cruisecontrolbutton"],
      },
      {
        targets: configMap["ADDONS"]["_f55_batterydecal"].targets,
        material: props.config["ADDONS"]["_f55_batterydecal"],
      },
      {
        targets: configMap["ADDONS"]["_f55_screendecal"].targets,
        material: props.config["ADDONS"]["_f55_screendecal"],
      },
    ];
  }

  static sideGuardsMaterials(configMap, props) {
    return [
      {
        targets: configMap["SIDEGUARDS"]["_rubber_color"].targets,
        material: props.config["SIDEGUARDS"]["_rubber_color"],
      },
      {
        targets: configMap["SIDEGUARDS"]["_metal_color"].targets,
        material: props.config["SIDEGUARDS"]["_metal_color"],
      },
      {
        targets: configMap["SIDEGUARDS"]["_carbon_color"].targets,
        material: props.config["SIDEGUARDS"]["_carbon_color"],
      },
    ];
  }

  static seatSlingMaterials(configMap, props) {
    return [
      {
        targets: configMap["SEAT_SLING"]["_cushion_color"].targets,
        material: props.config["SEAT_SLING"]["_cushion_color"],
      },
      {
        targets: configMap["SEAT_SLING"]["_middle_color"].targets,
        material: props.config["SEAT_SLING"]["_middle_color"],
      },
      {
        targets: configMap["SEAT_SLING"]["_metal_parts_color"].targets,
        material: props.config["SEAT_SLING"]["_metal_parts_color"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay_light"].targets,
        material: props.config["SEAT_SLING"]["_jay_light"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay_basic"].targets,
        material: props.config["SEAT_SLING"]["_jay_basic"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay_easy"].targets,
        material: props.config["SEAT_SLING"]["_jay_easy"],
      },
      {
        targets: configMap["SEAT_SLING"]["_soft_combi"].targets,
        material: props.config["SEAT_SLING"]["_soft_combi"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay_visco"].targets,
        material: props.config["SEAT_SLING"]["_jay_visco"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay_fushion"].targets,
        material: props.config["SEAT_SLING"]["_jay_fushion"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay_ion"].targets,
        material: props.config["SEAT_SLING"]["_jay_ion"],
      },
      {
        targets: configMap["SEAT_SLING"]["_jay2"].targets,
        material: props.config["SEAT_SLING"]["_jay2"],
      },
      {
        targets: configMap["SEAT_SLING"]["_bag_common"].targets,
        material: props.config["SEAT_SLING"]["_bag_common"],
      },
    ];
  }

  static rearWheelsMaterials(configMap, props) {
    return [
      {
        targets: configMap["REAR_WHEELS"]["hand_rim_color"].targets,
        material: props.config["REAR_WHEELS"]["hand_rim_color"],
      },
      {
        targets: configMap["REAR_WHEELS"]["rim_color"].targets,
        material: props.config["REAR_WHEELS"]["rim_color"],
      },
      {
        targets: configMap["REAR_WHEELS"]["_wheels"].targets,
        material: props.config["REAR_WHEELS"]["_wheels"],
      },
      {
        targets: configMap["REAR_WHEELS"]["_reflector"].targets,
        material: props.config["REAR_WHEELS"]["_reflector"],
      },
      {
        targets: configMap["REAR_WHEELS"]["_silver_rim_color"].targets,
        material: props.config["REAR_WHEELS"]["_silver_rim_color"],
      },
      {
        targets: configMap["REAR_WHEELS"]["_black_rim_color"].targets,
        material: props.config["REAR_WHEELS"]["_black_rim_color"],
      },
      {
        targets: configMap["REAR_WHEELS"]["_black_color"].targets,
        material: props.config["REAR_WHEELS"]["_black_color"],
      },
    ];
  }

  static frameMaterials(configMap, props) {
    return [
      {
        targets: configMap["FRAME"]["frame_color"].targets,
        material: props.config["FRAME"]["frame_color"],
      },
      {
        targets: configMap["FRAME"]["_strap_color"].targets,
        material: props.config["FRAME"]["_strap_color"],
      },
      {
        targets: configMap["FRAME"]["_frame_metal_color"].targets,
        material: props.config["FRAME"]["_frame_metal_color"],
      },
      {
        targets: configMap["FRAME"]["_frame_diffuse_black_color"].targets,
        material: props.config["FRAME"]["_frame_diffuse_black_color"],
      },
      {
        targets: configMap["FRAME"]["_rubber_color"].targets,
        material: props.config["FRAME"]["_rubber_color"],
      },
      {
        targets: configMap["FRAME"]["_frame_carbon_color"].targets,
        material: props.config["FRAME"]["_frame_carbon_color"],
      },
      {
        targets: configMap["FRAME"]["_frame_carbon_color"].targets,
        material: props.config["FRAME"]["_frame_carbon_color"],
      },
      {
        targets: configMap["FRAME"]["_led_case"].targets,
        material: props.config["FRAME"]["_led_case"],
      },
      {
        targets: configMap["FRAME"]["_led_colour"].targets,
        material: props.config["FRAME"]["_led_colour"],
      },
      {
        targets: configMap["FRAME"]["frame_bracket_colour"].targets,
        material: props.config["FRAME"]["frame_bracket_colour"],
      },
      {
        targets: configMap["FRAME"]["frame_bracket_colour"].targets,
        material: props.config["FRAME"]["frame_bracket_colour"],
      },
      {
        targets: configMap["FRAME"]["frame_clamp_colour"].targets,
        material: props.config["FRAME"]["frame_clamp_colour"],
      },

      {
        targets: configMap["FRAME"]["_level_colour"].targets,
        material: props.config["FRAME"]["_level_colour"],
      },
      {
        targets: configMap["FRAME"]["sticker_colour"].targets,
        material: props.config["FRAME"]["sticker_colour"],
      },
      {
        targets: configMap["FRAME"]["sticker_dot_colour"].targets,
        material: props.config["FRAME"]["sticker_dot_colour"],
      },
      {
        targets: configMap["FRAME"]["axle_tube"].targets,
        material: props.config["FRAME"]["axle_tube"],
      },
    ];
  }

  static casterMaterials(configMap, props) {
    return [
      {
        targets: configMap["CASTERS"]["rim_color"].targets,
        material: props.config["CASTERS"]["rim_color"],
      },
      {
        targets: configMap["CASTERS"]["caster_fork_color"].targets,
        material: props.config["CASTERS"]["caster_fork_color"],
      },
      {
        targets: configMap["CASTERS"]["_tyre_rubber"].targets,
        material: props.config["CASTERS"]["_tyre_rubber"],
      },
      {
        targets: configMap["CASTERS"]["_metal_black"].targets,
        material: props.config["CASTERS"]["_metal_black"],
      },
      {
        targets: configMap["CASTERS"]["_metal_silver"].targets,
        material: props.config["CASTERS"]["_metal_silver"],
      },
    ];
  }

  static backrestMaterials(configMap, props) {
    return [
      {
        targets: configMap["BACKREST"]["back_rest_piping_color"].targets,
        material: props.config["BACKREST"]["back_rest_piping_color"],
      },
      {
        targets: configMap["BACKREST"]["_back_rest_color"].targets,
        material: props.config["BACKREST"]["_back_rest_color"],
      },
      {
        targets: configMap["BACKREST"]["_back_rest_metal_color"].targets,
        material: props.config["BACKREST"]["_back_rest_metal_color"],
      },
      {
        targets: configMap["BACKREST"]["_back_rest_rubber_color"].targets,
        material: props.config["BACKREST"]["_back_rest_rubber_color"],
      },
      {
        targets: configMap["BACKREST"]["_logo_color"].targets,
        material: props.config["BACKREST"]["_logo_color"],
      },
      {
        targets: configMap["BACKREST"]["_zipper_color"].targets,
        material: props.config["BACKREST"]["_zipper_color"],
      },
      {
        targets: configMap["BACKREST"]["_badge_text_color"].targets,
        material: props.config["BACKREST"]["_badge_text_color"],
      },
      {
        targets: configMap["BACKREST"]["_badge_2_color"].targets,
        material: props.config["BACKREST"]["_badge_2_color"],
      },
      {
        targets: configMap["BACKREST"]["_backrest_handlegripbutton"].targets,
        material: props.config["BACKREST"]["_backrest_handlegripbutton"],
      },
      {
        targets: configMap["BACKREST"]["bracket_colour"].targets,
        material: props.config["BACKREST"]["bracket_colour"],
      },
      {
        targets: configMap["BACKREST"]["_back_rest_carbon_color"].targets,
        material: props.config["BACKREST"]["_back_rest_carbon_color"],
      },
      {
        targets: configMap["BACKREST"]["_back_rest_metal_matt_color"].targets,
        material: props.config["BACKREST"]["_back_rest_metal_matt_color"],
      },
    ];
  }
}
